const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const ImageSearchServiceQuery: any = {
    getImageDatas: Backofficebff + '/v1/imageSearch/getimages',
    downloadImages: Backofficebff + '/v1/imageSearch/DownloadImages',
};
